<script setup lang="ts">import { createPropsRestProxy } from '/vue-macros/reactivity-transform/helper';
const content = createPropsRestProxy(__props, ["item","root"]);

import { computed } from "vue";

import { useBrandStore } from "@/stores/brand-store";
import Tooltip from "@/components/Tooltip/Tooltip.vue";

import type { TagBase } from "@/models/Tag";
import type { TooltipContentProps, TooltipRootProps } from "reka-ui";

withDefaults(defineProps<{ item: TagBase[]; root?: TooltipRootProps } & TooltipContentProps>(), {  })
const tooltip = computed(() => useBrandStore().viewerConfig.tooltip ?? {});
</script>
<template>
  <Tooltip :content-props="content" :root-props="root">
    <template #trigger>
      <slot :disabled="root?.disabled" />
    </template>
    <template #content>
      <template v-if="item.length > 0">
        <ul>
          <li v-for="tag in item" :key="`${tag.tagType}-${tag.name}`">{{ tag.tagType }}: {{ tag.name }}</li>
        </ul>
      </template>
      <h2 v-else>{{ (tooltip.ioa && tooltip.ioa.label) || "Instance" }} has no tags</h2>
    </template>
  </Tooltip>
</template>
